import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logoUrl: '',
    faviconUrl: '',
    pageTitle: '',
    userAvatar: '',
    cToken: '',
    contact: {},
    previewUrl: '',
    featureFlag: {}
    // siteCustomCss: '',
    // siteCustomJs: ''
  },
  getters: {
    logo(state: any): string {
      return state.logoUrl
    },
    favicon(state: any): string {
      return state.faviconUrl
    },
    pageTitle(state: any): string {
      return state.pageTitle || 'Memberships'
    },
    userAvatar(state: any): string {
      return state.userAvatar
    }
    // siteCustomJs(state: any): string {
    //   return state.siteCustomJs
    // },
    // siteCustomCss(state: any): string {
    //   return state.siteCustomCss
    // }
  },
  mutations: {
    SAVE_BRAND_DATA(state: any, payload) {
      state.logoUrl = payload.logoUrl
      state.faviconUrl = payload.faviconUrl
      state.pageTitle = payload.pageTitle || payload.title
      // state.siteCustomCss = payload.customCss || ''
      // state.siteCustomJs = payload.customJs || ''
    },
    SAVE_AVATAR(state: any, payload: string) {
      state.userAvatar = payload
    },
    SAVE_CHECKOUT_DATA(state: any, payload) {
      state.contact = payload
    },
    SAVE_DASHBOARD_DATA(state: any, payload) {
      state.cToken = payload.cToken
      state.previewUrl = payload.previewUrl
      state.featureFlag = payload.featureFlag
    }
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin]
})
